<template>
  <div :class="containerClassObject">
    <div v-if="!hideLabel" :id="`${id}-label`" class="wm-field-label">
      <label v-if="label" :for="id" :class="{required: required}" v-html="label"/>
    </div>
    <div class="wm-field-input">
      <date-picker
        :id="id"
        :value="value"
        @input="setValue"
      />
    </div>
    <validation-message-list
      v-if="!disabled || !readonly"
      :$v="$v"
      :property-path="name"
      :translation-name-space="validationMessageTranslationNameSpace"
    />
  </div>
</template>

<script>
import DatePicker from './DatePicker'
import ValidationMessageList from '../ValidationMessageList'
import InputField from './InputField'

export default {
  components: {
    DatePicker,
    ValidationMessageList
  },
  extends: InputField,
  props: {
    value: {
      type: Date,
      default: null
    }
  },
  methods: {
    setValue: function (newValue) {
      this.$emit('input', newValue)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/fields/DatePickerField.vue